import request from "@/utils/request";
import { apiConfig } from "../config/api";

// 用户证书信息分页列表
export function getUserCerPager(req, page) {
  return request({
    url: apiConfig.userCertificate.api.pager.url,
    method: "post",
    data: {
      ...req,
      ...page,
    }
  });
}
// 用户证书信息分页列表搜索功能
export function searchUserCerPager(req, page) {
  return request({
    url: apiConfig.userCertificate.api.searchPager.url,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      examName: req.examName,
      agentName: req.agentName,
      storageStatus: req.storageStatus,
      paperStatus: req.paperStatus,
      storageStartDate: req.storageStartDate,
      storageEndDate: req.storageEndDate,
      issuingStartDate: req.issuingStartDate,
      issuingEndDate: req.issuingEndDate,
      isRec: req.isRec,
      agentIds: req.agentIds,
      isExport: req.isExport,
      page: page.page,
      pageSize: page.pageSize
    }
  });
}
// 查看用户证书
export function viewCertificateImg(req) {
  return request({
    url: apiConfig.userCertificate.api.viewCertificateImg.url,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
// 查看电子证书信息
export function getDigitalCertificateList(req) {
  return request({
    url: apiConfig.userCertificate.api.getDigitalCertificateList.url,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
// 查看纸质证书信息
export function getPaperCertificateInfo(id) {
  return request({
    url: apiConfig.userCertificate.api.getPaperCertificateInfo.url,
    method: "get",
    params: {
      id: id
    }
  });
}
// 标记纸质证书购买状态
export function editPaperCertificateStatus(req) {
  return request({
    url: apiConfig.userCertificate.api.editPaperCertificateStatus.url,
    method: "post",
    data: {
      id: req.id,
      paperStatus: req.paperStatus
    }
  });
}
// 批量标记纸质证书购买状态
export function editPaperCertificateStatusBatch(req) {
  return request({
    url: apiConfig.userCertificate.api.editPaperCertificateStatusBatch.url,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
// 上传购买纸质证书用户
export function uploadPaperCertificateUser(req) {
  return request({
    url: apiConfig.userCertificate.api.uploadPaperCertificateUser.url,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
// 导出入库信息
export function exportUserCertificate(searchForm) {
  return request({
    url: apiConfig.userCertificate.api.exportUserCertificate.url,
    method: "post",
    data: searchForm,
    responseType: "blob"
  });
}
// 导出选中入库信息
export function exportUserCertificateSelect(searchForm) {
  return request({
    url: apiConfig.userCertificate.api.exportUserCertificateSelect.url,
    method: "post",
    data: searchForm,
    responseType: "blob"
  });
}
// 导出证书zip
export function exportZip(data) {
  return request({
    url: apiConfig.userCertificate.api.exportZip.url,
    method: "post",
    data: data,
    responseType: "blob"
  });
}

//根据userId,ProjectId查询证书编号
export function getCerCode(req) {
  return request({
    url: apiConfig.userCertificate.api.getCerCode.url,
    method: "get",
    params: {
      userId: req.userId,
      projectId: req.projectId
    }
  });
}
